<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="flex flex-col" v-loading="loading">
      <div>
       <div class="flex justify-center mb-8">
        <span> 
          <svg width="110" height="110" viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M110 44.1555V52.471L55.0002 93.4509L54.9765 93.4679L0 52.471V44.1555L15.2217 32.4813H94.7786L110 44.1555Z" fill="#186A81"/>
            <path d="M110 44.1555V52.471L55 93.4509V32.4813H94.7784L110 44.1555Z" fill="#00465F"/>
            <path d="M96.0354 0V64.1996L55.0259 91.2517L55.0001 91.2346L13.9648 64.1912V0L96.0354 0Z" fill="#EAF4F4"/>
            <path d="M96.0353 0V64.1996L55.0258 91.2517L55 91.2346V0L96.0353 0Z" fill="#CAE8EA"/>
            <path d="M110 58.8967V110H0V52.4705L54.9765 87.0414L55.026 87.0734L110 58.8967Z" fill="#FFE26F"/>
            <path d="M110 52.4705V110H54.9766V87.0414L55.026 87.0734L110 52.4705Z" fill="#FFC271"/>
            <path d="M55.0007 69.1243C70.0201 69.1243 82.1957 56.9487 82.1957 41.9293C82.1957 26.9099 70.0201 14.7343 55.0007 14.7343C39.9813 14.7343 27.8057 26.9099 27.8057 41.9293C27.8057 56.9487 39.9813 69.1243 55.0007 69.1243Z" fill="#00DC7B"/>
            <path d="M82.195 41.9293C82.195 56.9254 69.9961 69.1243 55 69.1243V14.7343C69.9961 14.7343 82.195 26.9331 82.195 41.9293Z" fill="#00AA8E"/>
            <path d="M67.1817 37.1466L52.2006 52.1277L42.8184 42.7454L47.3752 38.1886L52.2006 43.014L55 40.2146L62.6249 32.5897L67.1817 37.1466Z" fill="white"/>
            <path d="M67.1817 37.1466L55 49.3283V40.2146L62.6248 32.5897L67.1817 37.1466Z" fill="#EAF4F4"/>
           </svg>
        </span>
       </div>
        <p class="text-center mb-3"> Done! You have succefully requested a transload. 
A notification has been sent to James Obinna.  </p>
      </div>

      <div class="flex items-center justify-center">
        <base-button
          text="Finsh"
          @click="closeModal"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
